var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46357312,3.81491597 C5.62292734,3.81491597 5.7511296,3.6867137 5.7511296,3.52735949 L5.7511296,2.61197136 C5.7511296,2.45261714 5.62292734,2.32441488 5.46357312,2.32441488 L0.67096512,2.32441488 C0.511610904,2.32441488 0.38340864,2.45261714 0.38340864,2.61197136 L0.38340864,3.52735949 C0.38340864,3.6867137 0.511610904,3.81491597 0.67096512,3.81491597 L5.46357312,3.81491597 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.1af68b39e248625c97d440137d761446.svg";
export { ForwardRef as ReactComponent };